<template>
  <div class="page-section-list-view">
    <section class="toolbar-card">
      <div>
        <h2>页面内容 Page Sections</h2>
        <p>维护页面描述、主图和图片组内容。</p>
      </div>
      <div class="toolbar-card__actions">
        <el-input
          v-model.trim="keyword"
          clearable
          placeholder="搜索标题/页面 Search"
          size="small"
          @keyup.enter.native="handleFilterChange"
          @clear="handleFilterChange"
        />
        <el-select v-model="pageFilter" clearable placeholder="页面 Page" size="small" @change="handleFilterChange">
          <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="typeFilter" clearable placeholder="类型 Type" size="small" @change="handleFilterChange">
          <el-option label="文字 Text" value="text" />
          <el-option label="图片组 Image Group" value="image_group" />
        </el-select>
        <el-select v-model="statusFilter" clearable placeholder="状态 Status" size="small" @change="handleFilterChange">
          <el-option label="草稿 Draft" value="draft" />
          <el-option label="启用 Active" value="active" />
        </el-select>
        <el-button size="small" @click="handleFilterChange">查询 Search</el-button>
        <el-button type="primary" size="small" @click="openCreateDialog">新增区块 Add Section</el-button>
      </div>
    </section>

    <section class="table-card">
        <el-table :data="sections" v-loading="loading" stripe>
        <el-table-column prop="pageKey" label="页面 Page" min-width="120" />
        <el-table-column prop="sectionKey" label="区块 Section" min-width="140" />
        <el-table-column label="使用位置 Usage" min-width="220">
          <template slot-scope="{ row }">
            <span class="usage-text">{{ sectionUsage(row.pageKey, row.sectionKey) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型 Type" min-width="130" />
        <el-table-column prop="title" label="标题 Title" min-width="180" />
        <el-table-column label="主图 Image" min-width="120">
          <template slot-scope="{ row }">
            <el-image v-if="row.image" class="table-thumb" :src="assetUrl(row.image)" :preview-src-list="[assetUrl(row.image)]" :alt="row.title" fit="cover" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="图片组 Images" min-width="120">
          <template slot-scope="{ row }">
            {{ Array.isArray(row.imagesJson) ? row.imagesJson.length : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="排序 Sort" min-width="140">
          <template slot-scope="{ row }">
            <el-input-number
              class="sort-input"
              :value="row.sortOrder"
              :min="0"
              :step="1"
              size="mini"
              @change="value => updateSectionSortOrder(row, value)"
            />
          </template>
        </el-table-column>
        <el-table-column label="状态 Status" min-width="150">
          <template slot-scope="{ row }">
            <el-switch
              :value="row.status === 'active'"
              active-text="启用 Active"
              inactive-text="草稿 Draft"
              @change="value => toggleSectionStatus(row, value)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作 Actions" min-width="190" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" @click="previewPageSection(row)">预览 Preview</el-button>
            <el-button type="text" @click="openEditDialog(row)">编辑 Edit</el-button>
            <el-button type="text" class="danger-btn" @click="handleDelete(row)">删除 Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handlePageSizeChange"
        />
      </div>
    </section>

    <el-dialog :title="dialogMode === 'create' ? '新增页面区块 Add Page Section' : '编辑页面区块 Edit Page Section'" :visible.sync="dialogVisible" width="860px" @closed="resetForm">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-tabs v-model="activeSectionTab" class="section-form-tabs">
          <el-tab-pane label="基础信息 Basic" name="basic">
            <div class="form-grid">
              <el-form-item label="页面 Page" prop="pageKey">
                <el-select v-model="form.pageKey" filterable allow-create placeholder="请选择或输入 Please select or type">
                  <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
              <el-form-item label="区块 Section" prop="sectionKey">
                <el-select v-model="form.sectionKey" filterable allow-create placeholder="请选择或输入 Please select or type">
                  <el-option v-for="item in sectionOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </div>

            <el-alert
              class="usage-alert"
              :title="currentSectionUsage"
              type="info"
              :closable="false"
              show-icon
            />

            <div class="form-grid">
              <el-form-item label="类型 Type" prop="type">
                <el-select v-model="form.type" placeholder="请选择 Please select">
                  <el-option label="文字 Text" value="text" />
                  <el-option label="图片组 Image Group" value="image_group" />
                </el-select>
              </el-form-item>
              <el-form-item label="状态 Status" prop="status">
                <el-select v-model="form.status" placeholder="请选择 Please select">
                  <el-option label="草稿 Draft" value="draft" />
                  <el-option label="启用 Active" value="active" />
                </el-select>
              </el-form-item>
            </div>

            <div class="form-grid">
              <el-form-item label="标题 Title">
                <el-input v-model.trim="form.title" />
              </el-form-item>
              <el-form-item label="排序 Sort Order">
                <el-input-number v-model="form.sortOrder" :min="0" :step="1" />
              </el-form-item>
            </div>
          </el-tab-pane>

          <el-tab-pane label="文案 Content" name="content">
            <el-form-item label="描述 Description">
              <el-input v-model.trim="form.description" type="textarea" :rows="8" />
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="主图 Image" name="image">
            <el-form-item label="主图 Image">
              <div class="image-field">
                <el-input v-model.trim="form.image" placeholder="图片地址 Image URL" />
                <el-upload action="" :http-request="request => uploadImage('main', request)" :show-file-list="false" accept="image/*">
                  <el-button size="small" :loading="uploadingTarget === 'main'">上传 Upload</el-button>
                </el-upload>
                <el-button size="small" @click="openMediaPicker('main')">选择 Choose</el-button>
              </div>
              <el-image v-if="form.image" class="image-preview" :src="assetUrl(form.image)" :preview-src-list="[assetUrl(form.image)]" fit="cover" />
            </el-form-item>
          </el-tab-pane>

          <el-tab-pane label="图片组 Image Group" name="images">
            <el-form-item label="图片组 Image Group">
              <div class="image-group-list">
                <div v-for="(item, index) in form.imagesJson" :key="index" class="image-group-item">
                  <el-input v-model.trim="item.title" placeholder="图片标题 Image title" />
                  <el-input v-model.trim="item.subtitle" placeholder="副标题 Subtitle" />
                  <el-input v-model.trim="item.description" type="textarea" :rows="2" placeholder="描述 Description" />
                  <el-input v-model.trim="item.body" type="textarea" :rows="2" placeholder="正文 Body" />
                  <el-input v-model.trim="item.anchor" placeholder="锚点 Anchor" />
                  <el-input v-model.trim="item.row" placeholder="行号 Row" />
                  <el-input v-model.trim="item.href" placeholder="链接 Href" />
                  <el-input v-model.trim="item.to" placeholder="跳转路径 Link path" />
                  <el-input v-model.trim="item.image" placeholder="图片地址 Image URL" />
                  <el-upload action="" :http-request="request => uploadImage(index, request)" :show-file-list="false" accept="image/*">
                    <el-button size="small" :loading="uploadingTarget === index">上传 Upload</el-button>
                  </el-upload>
                  <el-button size="small" @click="openMediaPicker(index)">选择 Choose</el-button>
                  <div class="order-actions">
                    <el-button size="mini" :disabled="index === 0" @click="moveImageItem(index, -1)">上移 Up</el-button>
                    <el-button size="mini" :disabled="index === form.imagesJson.length - 1" @click="moveImageItem(index, 1)">下移 Down</el-button>
                  </div>
                  <el-button size="small" class="danger-btn" @click="removeImageItem(index)">删除 Delete</el-button>
                  <el-image v-if="item.image" class="group-preview" :src="assetUrl(item.image)" :preview-src-list="[assetUrl(item.image)]" :alt="item.title" fit="cover" />
                </div>
              </div>
              <el-button size="small" @click="addImageItem">添加图片 Add Image</el-button>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible = false">取消 Cancel</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">保存 Save</el-button>
      </span>
    </el-dialog>

    <media-picker-dialog
      :visible.sync="mediaPickerVisible"
      upload-module="page-section"
      @select="chooseMedia"
    />
  </div>
</template>

<script>
import { createPageSection, deletePageSection, fetchPageSections, updatePageSection } from '../../api/page-sections'
import { resolveAssetUrl, uploadMediaAsset } from '../../api/media'
import MediaPickerDialog from '../../components/MediaPickerDialog.vue'
import { openPreviewUrl, pageSectionPreviewUrl } from '../../utils/preview'

const pageOptions = [
  { label: '首页 Home', value: 'home' },
  { label: '产品 Products', value: 'products' },
  { label: '颜色 Colours', value: 'colours' },
  { label: '定制 Customize', value: 'customize' },
  { label: '实力 Strength', value: 'strength' },
  { label: '质量 Quality', value: 'quality' },
  { label: '保养 Care', value: 'care' },
  { label: '案例 Cases', value: 'cases' },
  { label: '知识 Knowledge', value: 'knowledge' },
  { label: '联系 Contact', value: 'contact' }
]

const sectionOptions = [
  { label: '头部 Hero', value: 'hero' },
  { label: '介绍 Intro', value: 'intro' },
  { label: '入口卡片 Teasers', value: 'teasers' },
  { label: '内容 Content', value: 'content' },
  { label: '产地 Origin', value: 'origin' },
  { label: '原料 Ingredients', value: 'ingredients' },
  { label: '表面 Surface', value: 'surface' },
  { label: '效果 Effect', value: 'effect' },
  { label: '结构 Structure', value: 'structure' },
  { label: '安装 Installation', value: 'installation' },
  { label: '图库 Gallery', value: 'gallery' },
  { label: '视频 Video', value: 'video' },
  { label: '联系 Contact', value: 'contact' }
]

const sectionUsageMap = {
  'home/hero': '首页顶部大图和主标题 Home hero',
  'home/intro': '首页创始人/品牌介绍 Founder intro',
  'home/strength': '首页 STRONGOVA Solid Wood Flooring 模块和 5 个优势 Home strength preview',
  'home/interests': '首页 The Strongova Product World 模块 Home product world',
  'home/video': '首页视频区块 Story video',
  'home/factory': '首页工厂区块 Factory preview',
  'home/gallery': '首页 Reference projects 图片组',
  'home/contact': '首页底部联系表单图片 Contact preview',
  'products/intro': '产品一级页 Natural wood floors 下方图片组',
  'products/surface': '产品一级页最下方图片标题组 Surface section',
  'colours/intro': '颜色一级页顶部介绍和色系图片 Colours intro',
  'customize/hero': '定制页顶部标题 Customize hero',
  'customize/gallery': '定制页顶部产品图库 Detail gallery',
  'customize/content': '定制页 Reference examples 图片组',
  'customize/contact': '定制页底部咨询表单图片 Advice form',
  'strength/hero': '实力页顶部大图和标题 Strength hero',
  'strength/intro': '实力页优势说明 Advantage intro',
  'strength/video': '实力页视频区块 Video',
  'quality/hero': '质量页顶部大图和标题 Quality hero',
  'quality/intro': '质量页介绍区块 Quality intro',
  'quality/teasers': '质量页入口卡片组 Quality teaser cards',
  'quality/origin': '质量页 Number 1 产地内容 Origin section',
  'quality/ingredients': '质量页 Number 2 原料内容 Ingredients section',
  'quality/surface': '质量页 Number 3 表面内容 Surface section',
  'quality/effect': '质量页 Number 4 体验效果图片组 Effect cards',
  'quality/structure': '质量页 Number 5 结构内容 Structure section',
  'quality/installation': '质量页 Number 6 安装方式列表 Installation section',
  'quality/gallery': '质量页颜色图片组 Colour gallery',
  'quality/content': '质量页规格/格式内容 Formats content',
  'quality/care': '质量页保养说明 Care section',
  'quality/disposal': '质量页处理/维护说明 Disposal section',
  'care/hero': '保养页顶部大图和标题 Care hero',
  'care/intro': '保养页步骤说明 Care guide',
  'care/video': '保养页视频区块 Video',
  'care/contact': '保养页联系表单区块 Contact form',
  'knowledge/hero': '知识页顶部大图和标题 Knowledge hero',
  'knowledge/video': '知识页视频/推荐内容区块 Video section',
  'contact/intro': '联系页顶部 CEO 信件区块 Contact intro',
  'contact/factory': '联系页工厂地图/工厂区块 Factory section',
  'contact/contact': '联系页 Sales Partner 区块',
  'contact/gallery': '联系页 Projects 图片组'
}

const createEmptyForm = () => ({
  id: null,
  pageKey: 'products',
  sectionKey: 'intro',
  type: 'text',
  title: '',
  description: '',
  image: '',
  imagesJson: [],
  sortOrder: 0,
  status: 'active'
})

export default {
  name: 'PageSectionListView',
  components: {
    MediaPickerDialog
  },
  data () {
    return {
      loading: false,
      submitting: false,
      dialogVisible: false,
      mediaPickerVisible: false,
      dialogMode: 'create',
      activeSectionTab: 'basic',
      uploadingTarget: '',
      pickerTarget: '',
      keyword: '',
      pageFilter: '',
      typeFilter: '',
      statusFilter: '',
      sections: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      pageOptions,
      sectionOptions,
      form: createEmptyForm(),
      rules: {
        pageKey: [{ required: true, message: '请输入页面标识 Please input page key.', trigger: 'blur' }],
        sectionKey: [{ required: true, message: '请输入区块标识 Please input section key.', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型 Please select type.', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态 Please select status.', trigger: 'change' }]
      }
    }
  },
  async created () {
    await this.loadData()
  },
  computed: {
    currentSectionUsage () {
      return this.sectionUsage(this.form.pageKey, this.form.sectionKey)
    }
  },
  methods: {
    assetUrl: resolveAssetUrl,
    sectionUsage (pageKey, sectionKey) {
      return sectionUsageMap[`${pageKey}/${sectionKey}`] || '暂无说明 Custom section'
    },
    sectionQueryParams () {
      return {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        keyword: this.keyword || undefined,
        pageKey: this.pageFilter || undefined,
        type: this.typeFilter || undefined,
        status: this.statusFilter || undefined
      }
    },
    async loadData () {
      this.loading = true
      try {
        const { data } = await fetchPageSections(this.sectionQueryParams())
        this.sections = Array.isArray(data) ? data : data.items
        this.pagination.total = Array.isArray(data) ? data.length : data.total
      } catch (error) {
        this.$message.error('页面内容加载失败 Failed to load page sections.')
      } finally {
        this.loading = false
      }
    },
    handleFilterChange () {
      this.pagination.page = 1
      this.loadData()
    },
    handlePageChange (page) {
      this.pagination.page = page
      this.loadData()
    },
    handlePageSizeChange (pageSize) {
      this.pagination.page = 1
      this.pagination.pageSize = pageSize
      this.loadData()
    },
    openCreateDialog () {
      this.dialogMode = 'create'
      this.activeSectionTab = 'basic'
      this.dialogVisible = true
    },
    openEditDialog (row) {
      this.dialogMode = 'edit'
      this.activeSectionTab = row.type === 'image_group' ? 'images' : 'basic'
      this.form = {
        id: row.id,
        pageKey: row.pageKey || 'products',
        sectionKey: row.sectionKey || 'intro',
        type: row.type || 'text',
        title: row.title || '',
        description: row.description || '',
        image: row.image || '',
        imagesJson: Array.isArray(row.imagesJson) ? row.imagesJson.map(item => ({ ...item })) : [],
        sortOrder: row.sortOrder || 0,
        status: row.status || 'draft'
      }
      this.dialogVisible = true
    },
    resetForm () {
      this.form = createEmptyForm()
      this.activeSectionTab = 'basic'
      if (this.$refs.form) this.$refs.form.resetFields()
    },
    addImageItem () {
      this.form.imagesJson.push({ title: '', subtitle: '', description: '', body: '', anchor: '', row: '', href: '', to: '', image: '' })
    },
    removeImageItem (index) {
      this.form.imagesJson.splice(index, 1)
    },
    moveImageItem (index, direction) {
      const targetIndex = index + direction
      if (targetIndex < 0 || targetIndex >= this.form.imagesJson.length) return

      const nextImages = this.form.imagesJson.slice()
      const current = nextImages[index]
      nextImages.splice(index, 1)
      nextImages.splice(targetIndex, 0, current)
      this.form.imagesJson = nextImages
    },
    openMediaPicker (target) {
      this.pickerTarget = target
      this.mediaPickerVisible = true
    },
    chooseMedia (item) {
      if (this.pickerTarget === 'main') {
        this.form.image = item.fileUrl
      } else if (this.form.imagesJson[this.pickerTarget]) {
        this.form.imagesJson[this.pickerTarget].image = item.fileUrl
      }
      this.mediaPickerVisible = false
    },
    previewPageSection (row) {
      openPreviewUrl(pageSectionPreviewUrl(row))
    },
    async uploadImage (target, { file }) {
      if (this.uploadingTarget !== '') return
      this.uploadingTarget = target
      try {
        const { data } = await uploadMediaAsset(file, 'page-section')
        if (target === 'main') {
          this.form.image = data.fileUrl
        } else if (this.form.imagesJson[target]) {
          this.form.imagesJson[target].image = data.fileUrl
        }
        this.$message.success('图片已上传 Image uploaded.')
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || '上传失败 Upload failed.')
      } finally {
        this.uploadingTarget = ''
      }
    },
    handleSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid || this.submitting) return
        this.submitting = true
        try {
          const payload = {
            ...this.form,
            imagesJson: this.form.imagesJson.filter(item => item.title || item.image)
          }
          if (this.dialogMode === 'create') {
            await createPageSection(payload)
            this.$message.success('页面区块已创建 Page section created.')
          } else {
            await updatePageSection(this.form.id, payload)
            this.$message.success('页面区块已更新 Page section updated.')
          }
          this.dialogVisible = false
          await this.loadData()
        } catch (error) {
          this.$message.error((error.response && error.response.data && error.response.data.message) || '保存失败 Save failed.')
        } finally {
          this.submitting = false
        }
      })
    },
    buildSectionPayload (row, overrides = {}) {
      return {
        pageKey: row.pageKey,
        sectionKey: row.sectionKey,
        type: row.type || 'text',
        title: row.title || '',
        description: row.description || '',
        image: row.image || '',
        imagesJson: Array.isArray(row.imagesJson) ? row.imagesJson : [],
        sortOrder: row.sortOrder || 0,
        status: row.status || 'draft',
        ...overrides
      }
    },
    async toggleSectionStatus (row, enabled) {
      const previousStatus = row.status
      const nextStatus = enabled ? 'active' : 'draft'
      row.status = nextStatus

      try {
        await updatePageSection(row.id, this.buildSectionPayload(row, { status: nextStatus }))
        this.$message.success('状态已更新 Status updated.')
      } catch (error) {
        row.status = previousStatus
        this.$message.error((error.response && error.response.data && error.response.data.message) || '状态更新失败 Failed to update status.')
      }
    },
    async updateSectionSortOrder (row, value) {
      const previousSortOrder = row.sortOrder || 0
      const nextSortOrder = Number(value || 0)
      row.sortOrder = nextSortOrder

      try {
        await updatePageSection(row.id, this.buildSectionPayload(row, { sortOrder: nextSortOrder }))
        this.$message.success('排序已更新 Sort order updated.')
      } catch (error) {
        row.sortOrder = previousSortOrder
        this.$message.error((error.response && error.response.data && error.response.data.message) || '排序更新失败 Failed to update sort order.')
      }
    },
    handleDelete (row) {
      this.$confirm(`确认删除页面区块“${row.title || row.sectionKey}”吗？\nConfirm deleting this page section?`, '删除确认 Delete Confirmation', {
        type: 'warning'
      }).then(async () => {
        try {
          await deletePageSection(row.id)
          this.$message.success('页面区块已删除 Page section deleted.')
          await this.loadData()
        } catch (error) {
          this.$message.error((error.response && error.response.data && error.response.data.message) || '删除失败 Delete failed.')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar-card,
.table-card {
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--panel);
  box-shadow: 0 16px 32px rgba(23, 20, 17, 0.04);
}

.toolbar-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px;
}

.toolbar-card h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
}

.toolbar-card p {
  margin: 8px 0 0;
  color: var(--muted);
}

.toolbar-card__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.toolbar-card__actions .el-input,
.toolbar-card__actions .el-select {
  width: 180px;
}

.table-card {
  margin-top: 18px;
  padding: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  padding: 14px 4px 2px;
}

.usage-text {
  color: var(--muted);
  font-size: 13px;
  line-height: 1.5;
}

.usage-alert {
  margin: 0 0 18px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.sort-input {
  width: 112px;
}

.section-form-tabs {
  margin-top: -8px;
}

.section-form-tabs ::v-deep .el-tabs__content {
  overflow: visible;
  padding-top: 16px;
}

.table-thumb {
  display: block;
  width: 72px;
  height: 54px;
  object-fit: cover;
  border-radius: 6px;
  background: #f2eee8;
}

.image-field {
  display: flex;
  gap: 10px;
}

.image-field .el-input {
  flex: 1;
}

.image-preview {
  display: block;
  width: 220px;
  max-width: 100%;
  aspect-ratio: 4 / 3;
  margin-top: 10px;
  object-fit: cover;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: #f2eee8;
}

.image-group-list {
  display: grid;
  gap: 12px;
  margin-bottom: 10px;
}

.image-group-item {
  display: grid;
  grid-template-columns: minmax(120px, 0.8fr) minmax(160px, 1.2fr) auto auto auto auto 84px;
  gap: 8px;
  align-items: center;
  padding: 10px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.55);
}

.group-preview {
  width: 84px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  background: #f2eee8;
}

.order-actions {
  display: inline-flex;
  gap: 6px;
}

.picker-toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.picker-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  min-height: 260px;
}

.picker-card {
  overflow: hidden;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--panel);
  text-align: left;
  cursor: pointer;
}

.picker-card .el-image {
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
}

.picker-card span {
  display: block;
  overflow: hidden;
  padding: 8px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.danger-btn {
  color: #d14343;
}

@media (max-width: 960px) {
  .toolbar-card,
  .form-grid,
  .image-group-item {
    grid-template-columns: 1fr;
  }

  .toolbar-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .toolbar-card__actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .image-field {
    flex-direction: column;
  }
}
</style>
